import React from "react";
import ReturnToStart from "../returnToStart"
import ErrorMessage from "../errorMessage"

const FetchError = (props) => {
    if (!props.technician || !props.technician.fetchError) {
        return null;
    }
    return (
        <div>
            <div className="technicianNotFoundMessage">
                <ErrorMessage error={props.technician.error} />
            </div>
            <ReturnToStart />
        </div>        
        ); 
};
export default FetchError;